import { memo } from "react"
import styled from "styled-components"

const ControlSafe = styled.div`
  display: flex;
  padding: 6px;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
`

const IconWhiteEye = () => {
  return (
    <ControlSafe>
      <svg width="22" height="15" viewBox="0 0 22 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8.12566 7.14798C8.12566 5.60361 9.31799 4.35166 10.7888 4.35166C12.2596 4.35166 13.452 5.60361 13.452 7.14798C13.452 8.69234 12.2596 9.94429 10.7888 9.94429C9.31799 9.94429 8.12566 8.69234 8.12566 7.14798ZM9.8625 7.14798C9.8625 7.68515 10.2772 8.12061 10.7888 8.12061C11.3004 8.12061 11.7151 7.68515 11.7151 7.14798C11.7151 6.61081 11.3004 6.17534 10.7888 6.17534C10.2772 6.17534 9.8625 6.61081 9.8625 7.14798Z"
          fill="#646464"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M16.2425 2.00519L21.0825 6.06592C21.3955 6.32896 21.5776 6.72706 21.5776 7.14798C21.5776 7.56889 21.3955 7.967 21.0825 8.23003L16.2425 12.2908C13.0525 14.9643 8.52511 14.9643 5.33513 12.2908L0.495127 8.23003C0.182166 7.967 0 7.56889 0 7.14798C0 6.72706 0.182166 6.32896 0.495127 6.06592L5.33513 2.00519C8.52511 -0.668396 13.0525 -0.668396 16.2425 2.00519ZM6.41197 10.9291C8.9737 13.0699 12.6039 13.0699 15.1657 10.9291L19.5888 7.14798L15.1657 3.42766C12.6039 1.28685 8.9737 1.28685 6.41197 3.42766L1.98881 7.14798L6.41197 10.9291Z"
          fill="#646464"
        />
      </svg>
    </ControlSafe>
  )
}

export default memo(IconWhiteEye)
